(() => {
  function init(root = document) {
    root.querySelectorAll('[data-curated-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const photos = JSON.parse(gallery.querySelector('[data-photo-data]').textContent);
      if (!photos.length) return;
      const dialog = gallery.querySelector('dialog');
      const main = gallery.querySelector('[data-photo-main]');
      const large = gallery.querySelector('[data-photo-large]');
      const opener = gallery.querySelector('[data-photo-open]');
      let index = 0, previousOverflow = '', returnFocus = opener;
      const imageUrl = (photo, width) => { const url = new URL(photo.url, location.href); url.searchParams.set('width', width); return url.href; };
      const cache = new Map();
      const widths = [600, 1200, 2000, 3000];
      const largeSizes = '(max-width:749px) calc(100vw - 112px), (min-width:1459px) 1236px, calc(96vw - 164px)';
      function configure(image, photo, expanded) {
        image.sizes = expanded ? largeSizes : main.sizes;
        image.srcset = widths.map(width => `${imageUrl(photo, width)} ${width}w`).join(', ');
        image.src = imageUrl(photo, expanded ? 2000 : 1200);
        image.alt = photo.alt;
      }
      function warm(next, expanded = dialog.open) {
        const position = (next + photos.length) % photos.length;
        const key = `${position}:${expanded}`;
        if (cache.has(key)) return;
        const image = new Image();
        image.decoding = 'async';
        image.fetchPriority = 'low';
        configure(image, photos[position], expanded);
        cache.set(key, image);
        image.decode().catch(() => { cache.delete(key); });
        if (cache.size > 10) cache.delete(cache.keys().next().value);
      }
      function warmNeighbours() {
        warm(index + 1);
        if (!navigator.connection?.saveData) { warm(index + 2); warm(index - 1); }
      }
      function show(next) {
        index = (next + photos.length) % photos.length;
        const photo = photos[index];
        if (dialog.open) {
          configure(large, photo, true);
          gallery.querySelector('[data-photo-original]').href = photo.url;
        } else configure(main, photo, false);
        gallery.querySelectorAll('[data-photo-count]').forEach(el => { el.textContent = `${index + 1} / ${photos.length}`; });
        gallery.querySelectorAll('[data-photo-index]').forEach(el => el.setAttribute('aria-pressed', String(el.closest('.avgar-curated__groups') ? photos[Number(el.dataset.photoIndex)].category === photo.category : Number(el.dataset.photoIndex) === index)));
        if (dialog.open) gallery.querySelector(`.avgar-curated__strip [data-photo-index="${index}"]`).scrollIntoView({block:'nearest',inline:'nearest'});
        warmNeighbours();
      }
      gallery.querySelectorAll('[data-photo-next]').forEach(el => el.addEventListener('click', () => show(index + 1)));
      gallery.querySelectorAll('[data-photo-prev]').forEach(el => el.addEventListener('click', () => show(index - 1)));
      gallery.querySelectorAll('[data-photo-index]').forEach(el => el.addEventListener('click', () => show(Number(el.dataset.photoIndex))));
      function openGallery(trigger) {
        returnFocus = trigger;
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        show(index);
      }
      opener.addEventListener('click', () => openGallery(opener));
      gallery.addEventListener('avgar:open-gallery', event => openGallery(event.detail.trigger));
      document.addEventListener('shopify:block:select', event => {
        if (gallery.contains(event.target)) { const button = event.target.closest('[data-photo-index]'); if (button) show(Number(button.dataset.photoIndex)); }
      });
      gallery.querySelector('[data-photo-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { document.documentElement.style.overflow = previousOverflow; show(index); returnFocus.focus({preventScroll:true}); });
      opener.addEventListener('pointerenter', () => { warm(index, true); warm(index + 1, true); });
      opener.addEventListener('focus', () => warm(index, true));
      const nearby = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { warmNeighbours(); nearby.disconnect(); }
      }, {rootMargin:'300px'});
      nearby.observe(main);
      gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
      });
      [main, large].forEach(image => {
        let startX = null, startY = null;
        image.addEventListener('touchstart', event => {
          startX = event.touches.length === 1 ? event.touches[0].clientX : null;
          startY = event.touches.length === 1 ? event.touches[0].clientY : null;
        }, {passive:true});
        image.addEventListener('touchend', event => {
          if (startX === null) return;
          const dx = event.changedTouches[0].clientX - startX;
          const dy = event.changedTouches[0].clientY - startY;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
          startX = startY = null;
        }, {passive:true});
        image.addEventListener('touchcancel', () => { startX = startY = null; }, {passive:true});
      });
    });
  }
  if (!window.avgarGalleryLinksBound) {
    window.avgarGalleryLinksBound = true;
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#AvgarGallery"]');
      if (!link) return;
      const gallery = document.querySelector('[data-curated-gallery][data-ready="true"]');
      if (!gallery) return;
      event.preventDefault();
      gallery.dispatchEvent(new CustomEvent('avgar:open-gallery', {detail: {trigger: link}}));
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
